import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';
import { DatePipe } from '@angular/common';

@Injectable()
export class BinnacleService {

  constructor(public http: Http, public mainService: MainService,
    private datePipe: DatePipe) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"binnacle")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findBetweenDates(initialDate:Date,finalDate:Date) {
    let request = {initialDate: this.datePipe.transform(initialDate,"dd/MM/yyyy HH:mm:ss", 'UTC'),
      finalDate: this.datePipe.transform(finalDate,"dd/MM/yyyy HH:mm:ss", 'UTC')}
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"binnacle/findBinnacleBetweenDates",request)
      .toPromise()
      .then(
        res => { // Success
          resolve(res.json());
        },
        msg => { // Error
          reject(msg);
        }
      );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/binnacle.service.ts